<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <div class="navbar-brand">Consolidated Daily Sales Report</div>
        <div class="ms-auto d-flex flex-row">
            <div class="d-flex flex-row align-items-center px-2" style="gap: 10px">
                <span>Month/Year</span>
                <input type="month" [min]="startPeriod" [(ngModel)]="filterMonth" (change)="monthChange($event)"
                    class="form-control form-control-sm" [disabled]="is_loading || !!savingDate" *ngIf="is_mario" />
                <select class="form-control form-control-sm" [(ngModel)]="filterMonth"
                    (change)="monthChange($event)" [disabled]="is_loading || !!savingDate" *ngIf="!is_mario">
                    <option *ngFor="let month of months" [value]="month.value">{{month.label}}</option>
                </select>
            </div>
        </div>
    </div>
</nav>
<div class="text-muted small px-3 pt-1" style="opacity:.5" *ngIf="!is_loading && companies.length && !shareholder">
    {{parentCompany.name || 'Consolidated'}} · {{companies.length}} companies combined · MYR
</div>
<p class="text-muted small px-3" *ngIf="!shareholder">Consolidated Adj In / Adj Out are in MYR and change only this report’s balance. Branch figures stay unchanged.</p>
<hr />
<div class="alert alert-info" role="status" *ngIf="saveMessage">{{saveMessage}}</div>

<div class="report-loading" *ngIf="is_loading" role="status" aria-live="polite">
    <div class="spinner-border text-primary" aria-hidden="true"></div>
    <span>Loading report...</span>
</div>
<div class="alert alert-danger" *ngIf="error">{{error}}</div>
<div class="alert alert-info" *ngIf="!is_loading && !error && companies.length === 0">
    No assigned companies are available.
</div>
<div class="alert alert-info" *ngIf="!is_loading && !error && companies.length && weeks.length === 0">
    No Data Available
</div>

<div class="table-responsive"><table *ngIf="!is_loading && !error && weeks.length">
    <tbody *ngFor="let week of weeks; let i = index">
        <tr>
            <th colspan="16">Week {{i + 1}}</th>
        </tr>
        <tr>
            <th>Date</th>
            <th>Day</th>
            <th>Debit 进钱</th>
            <th>Credit 出钱</th>
            <th>GW Fees</th>
            <th>Balance</th>
            <th>Bonus</th>
            <th>New Member</th>
            <th>Old Member</th>
            <th>No Of Topup</th>
            <th>Bank In Capital</th>
            <th>Bank Withdraw</th>
            <th>Consolidated Adj In</th><th>Consolidated Adj Out</th><th>Save</th>
            <th>Checked</th>
        </tr>
        <tr *ngFor="let day of week">
            <td class="date-cell">{{day.date | date: 'dd'}}</td>
            <td class="date-cell">{{day.day}}</td>
            <td class="fw-bold" *ngFor="let column of moneyColumns"
                [ngClass]="{'text-danger': day[column.key] < 0}">
                <div class="d-flex justify-content-between">
                    <span>RM</span>{{(day[column.key] ?? 0) | number: '1.2-2'}}
                </div>
            </td>
            <td class="fw-bold text-center">{{day.new_member | number: '1.0-0'}}</td>
            <td class="fw-bold text-center">{{day.old_member | number: '1.0-0'}}</td>
            <td class="fw-bold text-center">{{day.no_of_topup | number: '1.0-0'}}</td>
            <td class="fw-bold" *ngFor="let column of bankColumns"
                [ngClass]="{'text-danger': day[column.key] < 0}">
                <div class="d-flex justify-content-between">
                    <span>RM</span>{{(day[column.key] ?? 0) | number: '1.2-2'}}
                </div>
            </td>
            <td><input type="number" min="0" step="0.01" class="form-control form-control-sm" style="min-width:100px"
                *ngIf="day.adjustment_edit" [attr.aria-label]="'Consolidated Adj In ' + day.date"
                [(ngModel)]="day.adjustment_edit.adj_in" [disabled]="!day.adjustment_edit.can_edit || !!savingDate" /><span *ngIf="shareholder">{{day.consolidated_adj_in | number: '1.2-2'}}</span></td>
            <td><input type="number" min="0" step="0.01" class="form-control form-control-sm" style="min-width:100px"
                *ngIf="day.adjustment_edit" [attr.aria-label]="'Consolidated Adj Out ' + day.date"
                [(ngModel)]="day.adjustment_edit.adj_out" [disabled]="!day.adjustment_edit.can_edit || !!savingDate" /><span *ngIf="shareholder">{{day.consolidated_adj_out | number: '1.2-2'}}</span></td>
            <td><button type="button" class="btn btn-primary btn-sm" *ngIf="day.adjustment_edit?.can_edit"
                [disabled]="!!savingDate" (click)="saveAdjustment(day)">Save</button></td>
            <td style="width:50px" class="p-0">
                <input type="checkbox" [checked]="day.checked" class="mx-auto d-block" disabled />
            </td>
        </tr>
        <tr class="total">
            <th colspan="2">Total</th>
            <th class="fw-bold" *ngFor="let column of moneyColumns"
                [ngClass]="{'text-danger': total(week, column.key) < 0}">
                <div class="d-flex justify-content-between">
                    <span>RM</span>{{total(week, column.key) | number: '1.2-2'}}
                </div>
            </th>
            <th class="text-center">{{total(week, 'new_member') | number: '1.0-0'}}</th>
            <th class="text-center">{{total(week, 'old_member') | number: '1.0-0'}}</th>
            <th class="text-center">{{total(week, 'no_of_topup') | number: '1.0-0'}}</th>
            <th class="fw-bold" *ngFor="let column of bankColumns"
                [ngClass]="{'text-danger': total(week, column.key) < 0}">
                <div class="d-flex justify-content-between">
                    <span>RM</span>{{total(week, column.key) | number: '1.2-2'}}
                </div>
            </th>
            <th>{{total(week, 'consolidated_adj_in') | number: '1.2-2'}}</th>
            <th>{{total(week, 'consolidated_adj_out') | number: '1.2-2'}}</th><th></th><th></th>
        </tr>
        <tr>
            <th colspan="16" style="height:30px; background: var(--bs-body-bg)"></th>
        </tr>
    </tbody>

    <tbody>
        <tr>
            <th colspan="2"></th>
            <th *ngFor="let column of moneyColumns">{{column.title}}</th>
            <th>New Member</th>
            <th>Old Member</th>
            <th>No Of Topup</th>
            <th *ngFor="let column of bankColumns">{{column.title}}</th>
<th>Consolidated Adj In</th><th>Consolidated Adj Out</th><th></th><th></th>
        </tr>
        <tr class="total-summary">
            <th colspan="2">Total</th>
            <th *ngFor="let column of moneyColumns"
                [ngClass]="{'text-danger': total(days, column.key) < 0}">
                {{total(days, column.key) | number: '1.2-2'}}
            </th>
            <th>{{total(days, 'new_member') | number: '1.0-0'}}</th>
            <th>{{total(days, 'old_member') | number: '1.0-0'}}</th>
            <th>{{total(days, 'no_of_topup') | number: '1.0-0'}}</th>
            <th *ngFor="let column of bankColumns"
                [ngClass]="{'text-danger': total(days, column.key) < 0}">
                {{total(days, column.key) | number: '1.2-2'}}
            </th>
<th>{{total(days, 'consolidated_adj_in') | number: '1.2-2'}}</th><th>{{total(days, 'consolidated_adj_out') | number: '1.2-2'}}</th><th></th><th></th>
        </tr>
    </tbody>
</table></div>

<app-company-share-report *ngIf="!is_loading && !error" [report]="shareSplit" [daily]="true"></app-company-share-report>
